import { render, staticRenderFns } from "./pieCharts.vue?vue&type=template&id=18eb93be&scoped=true"
import script from "./pieCharts.vue?vue&type=script&lang=ts"
export * from "./pieCharts.vue?vue&type=script&lang=ts"
import style0 from "./pieCharts.vue?vue&type=style&index=0&id=18eb93be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb93be",
  null
  
)

export default component.exports